@if (candidate) {
  <div
    class="candidate-card selectable"
    [class.revealed]="revealed"
    [class.selected]="candidate.isSelected">
    <div class="candidate-card__checkbox" (click)="onSelectCandidate()"></div>
    <div class="candidate-card__content">
      <div class="left-content-block">
        <a
          [routerLink]="['/profile', candidate.profileIds[0]]"
          target="_blank"
          class="profile__media">
          @if (picture$ | async; as picture) {
            <img
              alt="Profile picture"
              width="80"
              height="80"
              [src]="picture"
              (error)="onPictureError()" />
            <img
              alt="Profile picture"
              width="80"
              height="80"
              [src]="picture"
              class="profile__media-hover" />
          } @else {
            <span class="media-placeholder">
              <span class="media-placeholder__text">
                <app-candidate-name
                  [name]="candidate.fullName"
                  [getNameAbbreviation]="true"></app-candidate-name>
              </span>
            </span>
          }
        </a>
        <!--      ************ redesign: temporary hide: ************ -->
        <!--      @if (candidate.viewed) {-->
        <!--      <svg-->
        <!--        width="19"-->
        <!--        height="14"-->
        <!--        class="icon candidate-card__visited-icon">-->
        <!--        <use xlink:href="#visited-icon"></use>-->
        <!--      </svg>-->
        <!--      } @else {-->
        <!--      <svg-->
        <!--        width="20"-->
        <!--        height="20"-->
        <!--        class="icon candidate-card__visited-icon">-->
        <!--        <use xlink:href="#not-visited-icon"></use>-->
        <!--      </svg>-->
        <!--      }-->
        <div class="actions-block">
          <div class="actions-block__wrapper">
            <app-candidate-card-actions
              [type]="type"
              [candidate]="candidate"
              [picture]="picture$ | async"
              [index]="index"
              [revealed]="revealed"
              [folderId]="folderId"
              (removeFromFolder)="onRemoveFromFolder()"
              class="candidate-actions"></app-candidate-card-actions>
          </div>
        </div>
      </div>
      <div class="candidate-content">
        <div class="candidate-content-wrapper">
          <div
            class="candidate-card__header"
            [ngClass]="{ 'with-indicator-block': candidate.openToWork }">
            <div class="candidate-card__header-row main-row">
              @if (type === 'standard' && candidate.openToWork) {
                <div class="candidate-available">
                  <span class="candidate-available__text">
                    {{ 'CANDIDATE.OPEN_TO_WORK' | translate }}
                  </span>
                </div>
              }
              @if (type === 'forFolder' && candidate.folderStatus) {
                <app-folder-status
                  class="candidate-card__folder-status"
                  [status]="candidate.folderStatus"
                  [type]="'text'"
                  [selectable]="false"
                  (clickOnStatus)="onChangeFolderStatus()"></app-folder-status>
              }
              <div class="candidate-card__name-row">
                <a
                  [routerLink]="['/profile', candidate.profileIds[0]]"
                  target="_blank"
                  class="candidate-name">
                  <span class="candidate-name__text">
                    @if (candidate.fullName) {
                      {{ candidate.fullName }}
                    } @else {
                      {{ 'CANDIDATE.UNKNOWN_NAME' | translate }}
                    }
                  </span>
                </a>

                <div class="name-row-actions">
                  <app-open-messages-modal-button
                    class="messages-btn"
                    [profile]="candidate"></app-open-messages-modal-button>

                  @if (adjustmentState) {
                    <div class="adjustment-buttons">
                      <app-adjustment-label
                        type="like"
                        mode="button"
                        [showHint]="index === 0"
                        [active]="adjustmentState.currentType === 'like'"
                        [disabled]="adjustmentState.isInProgress || adjustmentState.isForbidden"
                        [loading]="
                          adjustmentState.isCurrentInProgress && adjustmentInProgressType === 'like'
                        "
                        (clicked)="onAdjustmentClick('like')"></app-adjustment-label>
                      <!-- Dislike is temporary disabled -->
                      <!-- <app-adjustment-label
                    type="dislike"
                    mode="button"
                    [active]="adjustmentState.currentType === 'dislike'"
                    [disabled]="adjustmentState.isInProgress || adjustmentState.isForbidden"
                    [loading]="
                      adjustmentState.isCurrentInProgress && adjustmentInProgressType === 'dislike'
                    "
                    (clicked)="onAdjustmentClick('dislike')">
                  </app-adjustment-label> -->
                    </div>
                  }
                </div>
              </div>
              <span class="candidate-position">
                {{ candidate.headLine }}
              </span>
            </div>
            <div class="candidate-card__header-row side-row">
              <span class="candidate-location">
                {{ candidate.location | location }}
              </span>
              @if (!revealed) {
                <ng-container *ngTemplateOutlet="candidateLinks"></ng-container>
              }
            </div>
          </div>
          <div class="candidate-card__main-content">
            @if (revealed) {
              <ng-container *ngTemplateOutlet="candidateLinks"></ng-container>
            }
            @if (candidate.skillGroupsMain?.length) {
              <app-candidate-card-skills
                [revealed]="revealed"
                [skillGroupsMain]="candidate.skillGroupsMain"
                class="profile-info"></app-candidate-card-skills>
            }
            <app-candidate-card-tags
              class="profile-info"
              [docId]="candidate.docId"
              [revealed]="revealed"></app-candidate-card-tags>
            @if (candidate.positions?.length) {
              <app-candidate-card-experience
                [revealed]="revealed"
                [positions]="candidate.positions"
                class="profile-info"></app-candidate-card-experience>
            }
            @if (revealed && candidate.languages?.length) {
              <app-profile-langs
                class="profile-info"
                [size]="'small'"
                [revealed]="revealed"
                [languages]="candidate.languages"></app-profile-langs>
            }
          </div>
        </div>
        <button
          class="btn btn--action candidate-card__show-more-btn"
          [class.revealed]="revealed"
          (click)="toggleRevealCard()">
          <span class="btn__text">
            @if (!revealed) {
              {{ 'GENERAL.SHOW_MORE' | translate }}
            } @else {
              {{ 'GENERAL.SHOW_LESS' | translate }}
            }
          </span>
          <svg width="20" height="20" class="icon btn__icon">
            <use xlink:href="#arrow-down"></use>
          </svg>
        </button>
        <app-candidate-card-contacts
          class="candidate-card__contacts"
          [profileId]="candidate.profileIds[0]"
          [type]="type"
          [contacts]="candidate.contacts"
          [showSearchContacts]="candidate.showSearchContacts"></app-candidate-card-contacts>
      </div>
    </div>
  </div>
}

<ng-template #candidateLinks>
  @if (candidate?.links) {
    <app-candidate-card-links
      class="candidate-links profile-info"
      [candidateSources]="candidate.links"
      [revealed]="revealed"></app-candidate-card-links>
  }
</ng-template>
